/**
 * Surface card with optional heading.
 * @param {{
 *   children: React.ReactNode,
 *   title?: string,
 *   description?: string,
 *   className?: string,
 * }} props
 */
export function Card({ children, title, description, className = '' }) {
  return (
    <div
      className={`rounded-xl border border-border bg-surface-raised p-6 shadow-sm ${className}`}
    >
      {title && (
        <h3 className="text-lg font-semibold text-text-primary">{title}</h3>
      )}
      {description && (
        <p className="mt-1 text-sm text-text-secondary">{description}</p>
      )}
      <div className={title || description ? 'mt-4' : ''}>{children}</div>
    </div>
  );
}